import { AREE } from '../../constants/areas';

/**
 * CoperturaAree — colonna destra della GRID dashboard: bar chart percentuali
 * delle aree con filtri cliccabili (multi-select).
 *
 * Props:
 *   - knownAreas   : array di chiavi area (es. ['business','lavoro','personale','salute'])
 *   - copPct       : { [area]: pct }
 *   - copCount     : { [area]: count }
 *   - totale       : numero totale di obiettivi
 *   - areaFilter   : array di chiavi attive
 *   - onToggle(a)  : callback toggle filtro
 *   - onClear()    : svuota filtri
 */
export default function CoperturaAree({
  knownAreas, copPct, copCount, totale,
  areaFilter, onToggle, onClear,
}) {
  return (
    <div className="md:col-span-7 lg:col-span-8" data-testid="coverage-bar-chart">
      <div className="flex items-baseline justify-between mb-6">
        <span className="mono-label">Copertura aree</span>
        <div className="flex items-baseline gap-3">
          {areaFilter.length > 0 && (
            <button
              onClick={onClear}
              className="font-mono text-[10px] uppercase tracking-[0.18em] text-soft hover:text-accent"
              data-testid="coverage-clear-filter"
            >
              Pulisci · {areaFilter.length}
            </button>
          )}
          <span className="font-mono text-xs text-soft">{totale} obiettivi</span>
        </div>
      </div>
      <div className="space-y-5">
        {knownAreas.map((a) => {
          const pct = copPct[a] || 0;
          const cnt = copCount[a] || 0;
          const meta = AREE[a];
          if (!meta) return null;
          const active = areaFilter.includes(a);
          const fadeOthers = areaFilter.length > 0 && !active;
          return (
            <button
              key={a}
              onClick={() => onToggle(a)}
              className="w-full text-left group focus:outline-none"
              data-testid={`coverage-area-${a}`}
              data-active={active ? '1' : '0'}
              title={active ? 'Rimuovi filtro' : `Filtra per ${meta.label}`}
              style={{ opacity: fadeOthers ? 0.4 : 1, transition: 'opacity 200ms ease-out' }}
            >
              <div className="flex items-baseline justify-between mb-2">
                <span
                  className="font-display text-sm md:text-base"
                  style={{
                    color: meta.color,
                    textDecoration: active ? 'underline' : 'none',
                    textDecorationThickness: '2px',
                    textUnderlineOffset: '4px',
                  }}
                >
                  {meta.label}
                </span>
                <span className="font-mono text-xs text-soft">
                  {cnt} · {Math.round(pct)}%
                  {active && <span className="ml-2 text-accent">●</span>}
                </span>
              </div>
              <div className="h-2 w-full bg-linesoft relative overflow-hidden">
                <div
                  className="h-full transition-[width] duration-700 ease-out group-hover:opacity-80"
                  style={{ width: `${pct}%`, backgroundColor: meta.color }}
                />
              </div>
            </button>
          );
        })}
      </div>
      {areaFilter.length > 0 && (
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.15em] text-soft">
          Filtri attivi: mostro solo gli obiettivi delle aree selezionate.
        </p>
      )}
    </div>
  );
}
